/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconThumbsDown(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M7.948 16H7.27a2.75 2.75 0 0 1-2.688-3.329L4.943 11H2.198C1.04 11 .016 10.105 0 8.88a20.096 20.096 0 0 1 1.227-7.185C1.62.629 2.645-.001 3.718-.001H15.98v8H12.6l-4.652 8zm-.856-1.513L11.737 6.5h2.743v-5H3.72c-.505 0-.929.292-1.083.711a18.596 18.596 0 0 0-1.135 6.65c.004.336.292.639.697.639h2.807a1.45 1.45 0 0 1 1.417 1.755l-.372 1.732a1.25 1.25 0 0 0 1.042 1.5z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13.117 24H11.72a3.5 3.5 0 0 1-3.424-4.228L8.886 17H4.04C2.293 17 .737 15.646.737 13.79c0-3.27.571-6.41 1.62-9.322C2.913 2.916 4.408 2 5.97 2H24v12h-5.109l-5.774 10zm-1.155-2 5.775-10H22V4H5.97c-.806 0-1.488.467-1.732 1.145a25.48 25.48 0 0 0-1.5 8.645c0 .645.55 1.21 1.303 1.21h4.845a2 2 0 0 1 1.956 2.416l-.59 2.772A1.5 1.5 0 0 0 11.72 22h.242z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconThumbsDown is deprecated and will be archived soon. Use IconThumbsDown instead.
 */
export function Experimental__IconThumbsDown(props) {
  return /*#__PURE__*/React.createElement(IconThumbsDown, props);
}